import React from "react";
import type { CountsMap } from "./usePlanningCountsCore";
import { PlanningCountsContext } from "./usePlanningCountsCore";

export const PlanningCountsProvider = ({ value, children }: { value: CountsMap; children: React.ReactNode }) => (
  <PlanningCountsContext.Provider value={value}>{children}</PlanningCountsContext.Provider>
);
